export default __webpack_public_path__ + "static/media/BioRhyme-Bold.a71102a0.ttf";